import { TOnChangeInTable } from "../../../../../../../components/custom/customDynamicTable"
import { Button, Checkbox, Form, InputNumber, TableColumnsType, TimePicker } from "antd"
import dayjs, { Dayjs } from "dayjs"
import 'dayjs/locale/ko';


interface IDayRenderProps {
    record: IProgramEventOutline
    propIdx: number
    dayListRecord: Record<number, (1 | 2 | 3 | 4 | 5 | 6 | 7)[]>
    startTimeRecord: Record<number, string>
    onClickApplyBtn?: (idx: number, isBooking: boolean) => void
    getDatesByWeekday: (targetDays: (1 | 2 | 3 | 4 | 5 | 6 | 7)[], idx: number, targetTime?: string) => void
    onChangeInTable?: TOnChangeInTable<IProgramEventOutline>
    onDeleteRow?: (idx: number) => void
}
const DayRender = ({ record, dayListRecord, startTimeRecord, onDeleteRow, propIdx, onClickApplyBtn, getDatesByWeekday, }: IDayRenderProps) => {
    const dayNumberList: [1, 2, 3, 4, 5, 6, 7] = [1, 2, 3, 4, 5, 6, 7]
    const toggleDay = (num: (1 | 2 | 3 | 4 | 5 | 6 | 7)) => {
        const newValue = dayListRecord?.[propIdx]?.includes(num)
            ? dayListRecord?.[propIdx]?.filter(q => q !== num)
            : [...dayListRecord?.[propIdx] ?? [], num]
        getDatesByWeekday(newValue, propIdx, startTimeRecord[propIdx]);
    }
    const onChangeStartTime = (startTime: Dayjs) => {
        getDatesByWeekday(dayListRecord[propIdx], propIdx, startTime?.format('HH:mm'))
    }
    return <>
        <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues?.isBooking !== currentValues?.isBooking}>
            {({ getFieldValue }) => <>
                {dayNumberList.map(q => <Button key={q} disabled={typeof record.id === 'string' && getFieldValue('isBooking')} type={dayListRecord?.[propIdx]?.includes(q) ? 'primary' : 'default'} onClick={() => { console.log('test'); toggleDay(q) }}>{dayjs().locale('ko').day(q).format('ddd')}</Button>)}

                <div>
                    <TimePicker disabled={typeof record.id === 'string' && getFieldValue('isBooking')} defaultValue={(dayjs(startTimeRecord[propIdx] ?? '00:00', 'HH:mm'))} width={123} format={'HH:mm'} minuteStep={5} onChange={onChangeStartTime} />
                </div>

                <div>
                    <Button disabled={typeof record.id === 'string' && getFieldValue('isBooking')} onClick={() => { onClickApplyBtn?.(propIdx, true) }}>적용</Button>
                    <Button disabled={typeof record.id === 'string' && getFieldValue('isBooking')} danger onClick={() => onDeleteRow?.(propIdx)}>삭제</Button>
                </div>
            </>
            }
        </Form.Item>
    </>
}

interface IMaxBookingCntRenderProps {
    propIdx: number
    programEventList: IProgramEvent[]
    onChangeInTable: TOnChangeInTable<IProgramEventOutline>
}
const MaxBookingCntRender = ({ programEventList, onChangeInTable, propIdx }: IMaxBookingCntRenderProps) => {
    return <>
        {programEventList.map((q, index) => {
            return <div key={index} style={{ height: '38px', display: 'flex', justifyContent: 'space-between', }}>
                <div style={{ display: 'flex', alignItems: 'center', }}>
                    {dayjs(q.targetDateTime)?.locale('ko')?.format('YYYY.MM.DD (ddd) HH:mm')}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues?.isBooking !== currentValues?.isBooking}>
                        {({ getFieldValue }) => <>
                            <InputNumber defaultValue={q.maxBookingCnt} disabled={typeof q.id === 'string' && getFieldValue('isBooking')} value={q.maxBookingCnt} onChange={e => !getFieldValue('isBooking') && onChangeInTable(propIdx, 'programEventList', programEventList.map((w, i) => i === index ? { ...w, maxBookingCnt: e ?? 0 } : w))} /> 명
                        </>
                        }
                    </Form.Item>
                </div>
            </div>
        })}
    </>
}

interface IsActiveRenderProps {
    propIdx: number
    programEventList: IProgramEvent[]
    onChangeInTable: TOnChangeInTable<IProgramEventOutline>
}
const IsActiveRender = ({ programEventList, onChangeInTable, propIdx }: IsActiveRenderProps) => {
    return <>
        {programEventList?.map((q, index) => <div key={index} style={{ height: '38px', display: 'flex', alignItems: 'center', }}>
            <Checkbox checked={q.isActive} onChange={() => onChangeInTable(propIdx, 'programEventList', programEventList.map((w, i) => i === index ? { ...w, isActive: !w.isActive } : w))} />
        </div>)}
    </>
}

const createGetColumnsFuntion = (dayListRecord: Record<number, (1 | 2 | 3 | 4 | 5 | 6 | 7)[]>, startTimeRecord: Record<number, string>, onClickApplyBtn: (idx: number, isBooking: boolean) => void, getDatesByWeekday: (targetDays: (1 | 2 | 3 | 4 | 5 | 6 | 7)[], idx: number, targetTime?: string) => void) => {

    const getColumns = (onChangeInTable: TOnChangeInTable<IProgramEventOutline>, onDeleteRow?: (idx: number) => void): TableColumnsType<IProgramEventOutline> => [
        {
            title: <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div>회차</div>
                <div style={{ color: 'var(--ant-color-text-description)', fontWeight: '400', fontSize: '12px' }}>※ 프로그램 기간 내 매주 반복됩니다.</div>
            </div>,
            dataIndex: 'day',
            width: '40%',
            render: (_value, record, idx) => {
                return <>
                    <DayRender record={record} propIdx={idx} dayListRecord={dayListRecord} startTimeRecord={startTimeRecord} onClickApplyBtn={onClickApplyBtn} getDatesByWeekday={getDatesByWeekday} onDeleteRow={onDeleteRow} />
                </>
            }
        },
        {
            title: '회차별 인원',
            dataIndex: 'programEventList',
            width: '50%',
            render: (value: IProgramEvent[], _, idx) => {
                return <>
                    <MaxBookingCntRender propIdx={idx} programEventList={value} onChangeInTable={onChangeInTable} />
                </>
            }
        },
        {
            title: '활성화',
            dataIndex: 'programEventList',
            width: '10%',
            render: (value: IProgramEvent[], _, idx) => {
                return <>
                    <IsActiveRender propIdx={idx} programEventList={value} onChangeInTable={onChangeInTable} />
                </>
            }
        },
    ]

    return getColumns
}

export { createGetColumnsFuntion }